.nest-alert {
  @apply flex
    items-center
    min-w-min mx-auto my-0
    p-3
    rounded;

  &--info {
    @apply bg-indigo-500;
    color: #fff;
  }

  &--success {
    background-color: #598527;
    color: #ffffff;
  }

  &--warning {
    background-color: #fff2c6;
    color: #000000;

  }

  &--error {
    background-color: #d5233f;
    color: #ffffff;
  }

}
